import React from "react";
import { storageHelper } from "../lib";

export default function Courses() {
  return(
    <section id="popular-courses" className="courses">
    <div className="container aos-init aos-animate" data-aos="fade-up">

      <div className="section-title">
        <h2>Courses</h2>
        <p>Popular Courses
        <div className="custom-button" style={{display: "flex", flexDirection: "row-reverse", color: "white"}}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={(storageHelper.get("refreshToken") && "/course") || "/courses" }className="get-started-btn">See All</a>
        </div>
        </p>
      </div>

      <div className="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">

        <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
          <div className="course-item">
            <img src="assets/img/subject/9thB.jpg" className="img-fluid" alt="..." />
            <div className="course-content">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Class 9th</h4>
                <p className="price">Rs. 1999/year</p>
              </div>

              <h3><a href="course-details.html">Maths , Science & HTML language</a></h3>
            </div>
          </div>
        </div> 

        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
          <div className="course-item">
            <img src="assets/img/subject/10thB.jpg" className="img-fluid" alt="..." />
            <div className="course-content">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Class 10th</h4>
                <p className="price">Rs. 1999/year</p>
              </div>

              <h3><a href="course-details.html">Maths + Science + HTML</a></h3>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
          <div className="course-item">
            <img src="assets/img/subject/11thA.jpg" className="img-fluid" alt="..." />
            <div className="course-content">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Class 11th</h4>
                <p className="price">Rs. 2699/year</p>
              </div>

              <h3><a href="course-details.html">Physics + Chemistry + Math</a></h3>
            </div>
          </div>
        </div> 

      </div>

    </div>
  </section>
  );
}